import React from 'react';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import hotelImg from '../../assets/images/hotel_under_dev.jpg'
import visaImg from '../../assets/images/visa_under_dev.jpg'

import FlightSearchpanel from '../searchPanels/flightSearchPanel/flight_search_panel';
import SportsSearchpanel from '../searchPanels/sportsSearchpanel/sports_search_panel';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import Modal from "react-modal";

function Banner() {
	const lang = useSelector(state => state.culture.language)
	const [searchParams] = useSearchParams();
	const [activeTab, setActiveTab] = useState(0);
	const navigate = useNavigate()
	const culture = useSelector((state) => state.culture.currentCulture);
	const [showHotelModal, setShowHotelModal] = useState(false);
    const [showVisaModal, setShowVisaModal] = useState(false);

	const forgotCloseHandler = () => {
		setShowVisaModal(false);
		setShowHotelModal(false);
		setActiveTab(0);
		
	};


	const handleTabClick = (index) => {
		debugger;
		setActiveTab(index);
	};

	const customStyles = {
        content: {
          top: "50%",
			left: "50%",
			right: "auto",
			bottom: "auto",
			marginRight: "-50%",
			transform: "translate(-50%, -50%)",
        },
      };

	useEffect(() => {
		let isSports = searchParams.get('Sports')

		if (isSports == "true") {
			setActiveTab(1)
		}
	}, [])

	return (
		
		<section className="Bannermain">
			<div className="container">
				<div className="row">
					<div className="col-lg-12 bnrcaption">
						<h1>{lang.your_world_of_joy} </h1>
						<p>{lang.find_what_makes_you_happy}</p>
					</div>
				</div>
			</div>
			<div className="col-lg-12 banner_search_section">
				<div className="container">
						<div className="homesearchpanel">
						<Tabs onSelect={handleTabClick} selectedIndex={activeTab}>
							<div className="hm_tab">
								<TabList>
									{' '}
									<Tab>
										{' '}
										<i className="hm_flight_icon"></i> {lang.search_pannel_flight}
									</Tab>{' '}
									<Tab onClick={(e) => {
										e.preventDefault();
										setShowHotelModal(true);
									}}>
										{' '}
										<i className="hm_htl_icon"></i> {lang.hotel}
									</Tab>{' '}
									<Tab onClick={(e) => {
										e.preventDefault();
										setShowVisaModal(true);
									}}>
										{' '}
										<i className="hm_visa_icon"></i> {lang.visa}
									</Tab>{' '}
									
									<Tab onClick={() => {
										navigate(`${process.env.REACT_APP_BASE_URL}${culture}/package-result`)
									}} >
										{' '}
										<i className="hm_staticPack_icon"></i> {lang.static_package || 'Static Package'} 
									</Tab>{' '}
									<Tab >
										{' '}
										<i className="hm_sports_icon"></i> {lang.search_pannel_sports}
									</Tab>{' '}
									
								</TabList>
							</div>
							<TabPanel>
								<FlightSearchpanel></FlightSearchpanel>
							</TabPanel>
							<TabPanel></TabPanel>
							<TabPanel></TabPanel>
							<TabPanel>Coming Soon..</TabPanel>
							<TabPanel>
								<SportsSearchpanel></SportsSearchpanel>
							</TabPanel>
						</Tabs>
						<Modal
							isOpen={showHotelModal}
							onRequestClose={() => setShowHotelModal(false)}
							contentLabel="Visa Modal"
							style={customStyles}
						 >
							<div className="popup_wrap">
								<div className="modal-dialog popup_wrap">
								<div className="modal-content">
									{" "}
									<div className="modal-body">
									<button
										onClick={forgotCloseHandler}
										type="button"
										className="close loginClose"
										data-dismiss="modal"
										aria-label="Close"
									>
										{" "}
									</button>
									<div className="log_cont_wrap">
										<div className="d-flex justify-content-between">
										<img src={hotelImg}/>
										</div>
									</div>
									</div>
								</div>
								</div>
							</div>
						</Modal>

			{/* Visa Modal */}
						<Modal
							isOpen={showVisaModal}
							onRequestClose={() => setShowVisaModal(false)}
							contentLabel="Visa Modal"
							style={customStyles}
						 >
							<div className="popup_wrap">
								<div className="modal-dialog popup_wrap">
								<div className="modal-content">
									{" "}
									<div className="modal-body">
									<button
										onClick={forgotCloseHandler}
										type="button"
										className="close loginClose"
										data-dismiss="modal"
										aria-label="Close"
									>
										{" "}
									</button>
									<div className="log_cont_wrap">
										<div className="d-flex justify-content-between">
										<img src={visaImg}/>
										</div>
									</div>
									</div>
								</div>
								</div>
							</div>
						</Modal>
					</div>
				</div>
			</div>
			 
		</section>
	);
}
export default Banner;
